export default {
  //* getNotifications ---------------------------------------------------------------------------------------------------------------

  async getNotifications({ rootGetters, commit }, dati) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getNotifications", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(dati),
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      // console.log(resp_json);
      commit("setNotifications", resp_json);
      return resp_json;
    }
  },
  //* getNotificationsAll ---------------------------------------------------------------------------------------------------------------

  async getNotificationsAll({ rootGetters, commit }, dati) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getNotificationsAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      // console.log(resp_json)
      // console.log(resp_json);
      commit("setNotifications", resp_json);
      return resp_json;
    }
  },

  //* markRead ---------------------------------------------------------------------------------------------------------------

  async markRead({ rootGetters }, id) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    // console.log(id)
    if (!id || id === "") {
      return;
    }
    const response = await fetch(
      base_address + "/notifications/markAsRead/" + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).catch((e) => console.log(e));
    if (response.ok) {
      return 200;
    }
    return 400;
  },

  //* markAllRead ---------------------------------------------------------------------------------------------------------------

  async markAllRead({ rootGetters }, id) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    // console.log(id)
    const response = await fetch(base_address + "/notifications/markAllRead/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      return 200;
    }
    return 400;
  },

  //* getGitVersion ---------------------------------------------------------------------------------------------------------------

  async getGitVersion({ rootGetters }) {
    // load quotes from backend
    var resp_json = {},
      base_address = rootGetters["settings/getBaseAddress"];
    const response = await fetch(base_address + "/getGitVersion", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response && response.ok) {
      resp_json = await response.json();
    }
    return resp_json;
  },
};
